import { filterUpdate } from 'store/search/searchActions';
import { createFilterUpdateEvent } from '../eventCreators';
import { CreateFilterUpdateEventPayload } from '../dataHelpers/createFilterUpdateEventPayload';

const emitFilterUpdateEvent = ({ payload }) => {
  return createFilterUpdateEvent(
    CreateFilterUpdateEventPayload({
      groupName: payload.groupName,
      itemName: payload.itemName,
      itemText: payload.itemText,
      itemType: payload.itemType,
      itemValue: payload.itemValue,
    }),
  );
};

// eslint-disable-next-line
// @ts-ignore
export default { [filterUpdate]: emitFilterUpdateEvent };
